module.exports = __webpack_public_path__ + "assets-cabinet/img/sending_unread.c277b02e.svg";